import * as Sentry from '@sentry/react';

type SentryErrorProps = {
	error: unknown;
	module: 'api_error_public_mutation' | 'api_error_mutation';
	activity: string | undefined;
};

const sendErrorToSentry = ({ error, module, activity }: SentryErrorProps): void => {
	Sentry.withScope((scope) => {
		scope.setTag('module', module);
		scope.setLevel('error');
		scope.setContext('additional_info', {
			activity: activity,
			time: new Date().toISOString(),
		});
		Sentry.captureException(error);
	});
};

export { sendErrorToSentry };
